import {
  FETCH_ADDRESSBOOK_ADDRESSES_BEGIN,
  FETCH_ADDRESSBOOK_ADDRESSES_SUCCESS,
  FETCH_ADDRESSBOOK_ADDRESSES_FAIL,
  CREATE_ADDRESSBOOK_ADDRESS_SUCCESS,
  CREATE_ADDRESSBOOK_ADDRESS_FAIL,
  UPDATE_ADDRESSBOOK_ADDRESS_SUCCESS,
  UPDATE_ADDRESSBOOK_ADDRESS_FAIL,
  DELETE_ADDRESSBOOK_ADDRESS_SUCCESS,
  DELETE_ADDRESSBOOK_ADDRESS_FAIL,
  ENABLE_ADDRESSBOOK_WHITELIST_SUCCESS,
  ENABLE_ADDRESSBOOK_WHITELIST_FAIL,
  DISABLE_ADDRESSBOOK_WHITELIST_SUCCESS,
  DISABLE_ADDRESSBOOK_WHITELIST_FAIL,
} from '../actions/types';

const initialState = {
  addressbook: [],
  success: [],
  errors: [],
};

const addressbook = (state = initialState, action) => {
  switch (action.type) {
    case FETCH_ADDRESSBOOK_ADDRESSES_BEGIN:
      return {
        ...state,
        loading: true,
      };
    case FETCH_ADDRESSBOOK_ADDRESSES_SUCCESS:
      return {
        ...state,
        addressbook: action.payload,
        loading: false,
      };
    case FETCH_ADDRESSBOOK_ADDRESSES_FAIL:
      return {
        ...state,
        loading: false,
        errors: action.errors.response.data,
      };
    case CREATE_ADDRESSBOOK_ADDRESS_SUCCESS:
      return {
        ...state,
        // success: { success: [action.payload.message] },
        loading: false,
      };
    case CREATE_ADDRESSBOOK_ADDRESS_FAIL:
      return {
        ...state,
        loading: false,
        errors: action.errors.response.data,
      };
    case UPDATE_ADDRESSBOOK_ADDRESS_SUCCESS:
      return {
        ...state,
        success: action.payload,
        loading: false,
      };
    case UPDATE_ADDRESSBOOK_ADDRESS_FAIL:
      return {
        ...state,
        loading: false,
        errors: action.errors.response.data,
      };
    case DELETE_ADDRESSBOOK_ADDRESS_SUCCESS:
      return {
        ...state,
        success: { success: [action.payload.message] },
        loading: false,
      };
    case DELETE_ADDRESSBOOK_ADDRESS_FAIL:
      return {
        ...state,
        loading: false,
        errors: action.errors.response.data,
      };
    case DISABLE_ADDRESSBOOK_WHITELIST_SUCCESS:
      return {
        ...state,
        success: { success: [action.payload.message] },
        loading: false,
      };
    case DISABLE_ADDRESSBOOK_WHITELIST_FAIL:
      return {
        ...state,
        loading: false,
        errors: action.errors.response.data,
      };
    case ENABLE_ADDRESSBOOK_WHITELIST_SUCCESS:
      return {
        ...state,
        success: { success: [action.payload.message] },
        loading: false,
      };
    case ENABLE_ADDRESSBOOK_WHITELIST_FAIL:
      return {
        ...state,
        loading: false,
        errors: action.errors.response.data,
      };
    default:
      return state;
  }
};

export default addressbook;
